import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';

import 'primeicons/primeicons.css' 
import '@/assets/main.css'

import './mixins'
import './plugins'
import './thirdParty'
import AlertPlugin from './plugins/alert.js';
import 'bootstrap/dist/css/bootstrap.min.css';

import utils from './plugins/utils';

import currentUser from './mixins/currentUser'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

console.time('AppStart');
console.log('Начало main.js');

const Vue = createApp(App);
Vue.use(router);
Vue.use(store);
Vue.use(utils);
Vue.use(PrimeVue, {
  theme: {
      preset: Aura,
      options: {
          prefix: 'p',
          darkModeSelector: '.my-app-dark'
      }
  },
  zIndex: {
    modal: 3000,   // dialogs, drawers (выше, чем все)
    overlay: 2000, // dropdowns, autocomplete, popover
    menu: 2000,    // overlay menus
    tooltip: 2500  // tooltips выше меню
  }
});
Vue.use(ConfirmationService);
Vue.component('ConfirmDialog', ConfirmDialog);

if (store.getters['ui/theme'] === 'dark') {
  document.documentElement.classList.add('my-app-dark');
}
Vue.use(AlertPlugin);

// Глобальная регистрация UI-компонент
const requireComponent = require.context(
  // Относительный путь до каталога компонентов
  '@/components/UI',
  // Обрабатывать или нет подкаталоги
  false,
  // Регулярное выражение для определения файлов базовых компонентов
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  // Получение конфигурации компонента
  const componentConfig = requireComponent(fileName)
  // Получение имени компонента в PascalCase
  const componentName = upperFirst(
    camelCase(
      // Получаем имя файла независимо от глубины вложенности
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  Vue.component(
    componentName,
    // Поиск опций компонента в `.default`, который будет существовать,
    // если компонент экспортирован с помощью `export default`,
    // иначе будет использован корневой уровень модуля.
    componentConfig.default || componentConfig
  )
}) 

Vue.mixin(currentUser)
Vue.mount('#app')

console.timeEnd('AppStart');